import { render } from "./OrderRefundProduct.vue?vue&type=template&id=3a27fbcc"
import script from "./OrderRefundProduct.vue?vue&type=script&lang=js"
export * from "./OrderRefundProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__